// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { FieldsHolder } from '../../commons';

type Props = {|
  children: Node,
|};

export function PaymentMethodBox({ children }: Props): Node {
  return (
    <Root>
      {children}
    </Root>
  );
}

const Root = styled(FieldsHolder)`
  border: 1px solid #dddddd;
  background: rgb(250, 250, 250);
`;
